import { render } from "./START.vue?vue&type=template&id=1560f936"
import script from "./START.vue?vue&type=script&lang=js"
export * from "./START.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__